<div id="form-container" style="margin: 5px; margin-left:10px;">
  <form [formGroup]="form" (ngSubmit)="onSubmit($event)">
    <formly-form [form]="form" [fields]="formFields" [model]="formProps"></formly-form>
  </form>
</div>
